import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";
import { PageHeader } from "@/components/app/page-header";
import { HelpPanel } from "@/components/app/help-panel";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export const Route = createFileRoute("/_authenticated/settings")({
  component: SettingsPage,
  head: () => ({ meta: [{ title: "Settings — InboxPulse" }] }),
});

function SettingsPage() {
  const { user } = useAuth();
  const { data: profile, refetch } = useQuery({
    queryKey: ["profile"],
    queryFn: async () =>
      (await supabase.from("profiles").select("*").eq("id", user!.id).single()).data,
  });
  const [name, setName] = useState("");
  useEffect(() => {
    if (profile?.display_name) setName(profile.display_name);
  }, [profile]);

  const save = async () => {
    const { error } = await supabase
      .from("profiles")
      .update({ display_name: name })
      .eq("id", user!.id);
    if (error) toast.error(error.message);
    else {
      toast.success("Saved");
      refetch();
    }
  };

  return (
    <div className="p-8 max-w-3xl">
      <PageHeader title="Settings" description="Your profile and account." />
      <HelpPanel
        title="Hilfe: Dein Konto"
        what={
          <>
            Hier änderst du <b>Anzeigename</b> und siehst deine Login-Mail. Mehr nicht — bewusst
            minimal gehalten.
          </>
        }
        why={
          <>
            Alle anderen Einstellungen (Alarme, Tracking, Domains) findest du in den jeweiligen
            Bereichen.
          </>
        }
        how={[
          <>Anzeige-Namen ändern.</>,
          <>
            <b>Speichern</b>. Fertig.
          </>,
        ]}
      />
      <Card className="p-6 bg-card/60 border-border space-y-4">
        <div className="space-y-2">
          <Label>Email</Label>
          <Input value={user?.email ?? ""} disabled />
        </div>
        <div className="space-y-2">
          <Label>Display name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <Button onClick={save} className="bg-[image:var(--gradient-primary)] hover:opacity-90">
          Save
        </Button>
      </Card>
    </div>
  );
}
